import React, { useState } from 'react'
import { postData } from '../../features/http/httpUtil'

const ReportCompromised = () => {
    const [email, setEmail] = useState('')
    const [error, setError] = useState('')
    const [message, setMessage] = useState('')
    //const dispatch = useDispatch()



    const handleForm = (event) => {
        event.preventDefault()
        postData('/api/accounts/report-compromised', {
            email: email,
        }).then((result) => {
            if (result.success) {
                setMessage(
                    'Please check your e-mail. If an account matching the provided e-mail address exists, further instructions have been sent to it.'
                )
            } else {
                setError('An error occurred.')
            }
        })
    }

    return (
        <div class="content-pane">
            <h1>Report Account Compromised</h1>

            <p>
            If you believe the security of your account has been compromised, please let us know immediately. We will lock your account and provide you instructions on how to recover it.
            </p>

            <form onSubmit={handleForm}>
                <table className="formTable">
                    <tbody>
                        <tr>
                            <td colSpan="2">
                                {error && (
                                    <span
                                        className="errorMessage"
                                        id="errorMessage"
                                    >
                                        {error}
                                    </span>
                                )}
                                {message && <span id="message">{message}</span>}
                                <br />
                            </td>
                        </tr>
                        <tr>
                            <td className="tdLabel">
                                <label htmlFor="emailAddress" className="label">
                                    E-mail Address
                                    <span className="required">*</span>:
                                </label>
                            </td>
                            <td>
                                <input
                                    type="email"
                                    className="emailAddress"
                                    size={40}
                                    maxLength={255}
                                    id="emailAddress"
                                    autofocus="autofocus"
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td colspan="2">
                                <div align="center">
                                    <input
                                        type="submit"
                                        id=""
                                        value="Continue"
                                        className="jq-button ui-button ui-widget ui-state-default ui-corner-all"
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </div>
    )
}

export default ReportCompromised
